const BYTE_ARRAY_INTERVAL = 49;

export const constants = {
	BYTE_ARRAY_INTERVAL
};

export default constants;
